
import axios from 'axios';
import { API_URL } from 'configs'


export const ACTIVITY_REQUEST='ACTIVITY_REQUEST'
export const  ACTIVITY_DROPDOWN_LIST_SUCCESS = ' ACTIVITY_DROPDOWN_LIST_SUCCESS'
export const ACTIVITY_VALIDATION_ERROR = 'ACTIVITY_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';

const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const validationError = notification => ({
  type: ACTIVITY_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const activityRequest = () => ({
  type:ACTIVITY_REQUEST,
})


const activityDropdownListSuccess = activitiesDropdownList => ({
    type: ACTIVITY_DROPDOWN_LIST_SUCCESS,
    activitiesDropdownList: activitiesDropdownList,
  })
  
  const activityFailure = notification => ({
    type: SHOW_SNACKBAR,
    snackbar_notification: notification,
    snackbar_notification_type: 'general_error'
  })

export const activityDropdownListFetch = (client_ids, category_ids, object_viewed_id = '') => {
    var token = localStorage.getItem("token")
    return dispatch => {
      dispatch(activityRequest())
      dispatch(showCommonLoader())
      return axios(API_URL + "activity/getAllActivitiesForDropdown", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization': 'Bearer ' + token
        },
        data: {
          client_ids: client_ids,
          category_ids: category_ids,
          object_viewed_id: object_viewed_id
        }
      })
      .then((response) => {
        dispatch(activityDropdownListSuccess(response.data))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error, dispatch)
        dispatch(hideCommonLoader())
      });
  
    }
  }






  const handleErrorResponse = (error, dispatch) => {
    try {
      if (error.response.status === 422 && error.response.data.error) {
        dispatch(validationError(error.response.data.error))
      }
      else if (error.response.status === 401 && error.response.data.error) {
        dispatch(tokenError(error.response.data.error.toString()))
      }
      else {
        let err = '';
        if (error.response.data.error) {
          err = error.response.data.error.toString()
        }
        else {
          err = error.response.status + ` ` + error.response.statusText
        }
        dispatch(activityFailure(err))
      }
    }
    catch (e) {
      dispatch(activityFailure('Unable to perform action.Something went wrong'))
    }
  }   